// extracted by mini-css-extract-plugin
module.exports = {"comparisonCell":"styles_comparisonCell__yKwaB","neutralText":"styles_neutralText__1tCck"};